import { DropDownList } from "@progress/kendo-react-dropdowns"
import style from './PaginatedList.module.scss'

const ItemsPerPageOptions = [ 10, 20, 50, 100 ]

interface PaginationDropDown{
  itemsPerPage: number,
  setItemsPerPage: (value: number) => void
}

export default function ItemsPerPageDropDown ({itemsPerPage, setItemsPerPage} : PaginationDropDown) {
  return (
    <>
      <DropDownList
        data={ItemsPerPageOptions}
        value={itemsPerPage}
        onChange={(e) => setItemsPerPage(Number(e.value))}
        className={style.dropdown}
        rounded={'full'}
      />
      <span className={style.text}> Items per page </span>
    </>
  )
}
